var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader'),_c('b-overlay',{attrs:{"show":_vm.assistant.isFetchingAssistant}},[_c('b-card',{staticClass:"mb-4"},[_c('AssistantForm',{attrs:{"assistant-detail":_vm.assistantDetail}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }